import * as React from "react";
import type { SVGProps } from "react";
const SvgFolder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.401 8.417v9.524a2 2 0 0 0 2 2H19.6a2 2 0 0 0 2-2V8.012a1 1 0 0 0-1-1h-8.516L9.319 4.06H3.4a1 1 0 0 0-1 1z"
    />
  </svg>
);
export default SvgFolder;
